<nz-layout class="h-screen">
  <nz-content>
    <div class="h-full bg-polka">
      <router-outlet></router-outlet>
    </div>
  </nz-content>
</nz-layout>
